<template>
	<div v-parallax-fit="parallax" class="slide-polaroid">
		<img src="/themes/rise-theme/dist/images/estate/character-view/henry/03_family08.png">
	</div>
</template>

<script>
	export default {
		data() {
			return {
				parallax: [
					{
						start: 2800,
						end: 3200,
						fromStyle: { transform: 'translateX(0%) translateY(0%) scale(0) rotateZ(0deg)' },
           				toStyle: { transform: 'translateX(0%) translateY(0%) scale(1) rotateZ(0deg)' },
						easing: 'linear'
					},
					{
						start: 3200,
						end: 3600,
						fromStyle: { transform: 'translateX(0%) translateY(0%) scale(1) rotateZ(0deg)' },
           				toStyle: { transform: 'translateX(-75%) translateY(30%) scale(1) rotateZ(-25deg)' },
						easing: 'linear'
					},
					{
						start: 3600,
						end: 4100,
						fromStyle: { transform: 'translateX(-75%) translateY(30%) scale(1) rotateZ(-25deg)' },
           				toStyle: { transform: 'translateX(-1000%) translateY(30%) scale(1) rotateZ(0deg)' },
						easing: 'linear'
					},
					{
						start: 4100,
						end: 5000,
						fromStyle: { transform: 'translateX(-1000%) translateY(30%) scale(1) rotateZ(0deg)' },
           				toStyle: { transform: 'translateX(-1500%) translateY(30%) scale(1) rotateZ(0deg)' },
						easing: 'linear'
					}
				]
			}
		}
	}
</script>

<style lang="scss" scoped>
	.slide-polaroid {
		max-width: 120px;
		position: absolute;
		left: 57%;
		top: -10%;
		z-index: 2;
		transition: all 0.1s linear;
	}

	@media screen and (max-width: 1680px) {
		.slide-polaroid {max-width: 100px;}
	}

	@media screen and (max-width: 1280px) {
		.slide-polaroid {max-width: 60px;}
	}

	@media screen and (max-width: 650px) {
		.slide-polaroid {max-width: 35px;}
	}
</style>
